require('./cardCancelDeferPurchaseView.scss');

// @vendors
const { Component } = require('react');
const { connect } = require('react-redux');
const PropTypes = require('prop-types');
const React = require('react');
const { withRouter } = require('react-router-dom');

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');

// @components
const CardCancelDeferPurchaseError = require('components/cards/cardCancelDeferPurchase/cardCancelDeferPurchaseError');
const CardCancelDeferPurchaseSuccess = require('components/cards/cardCancelDeferPurchase/cardCancelDeferPurchaseSuccess');
const CardCancelDeferPurchaseWizard = require('components/cards/cardCancelDeferPurchase/cardCancelDeferPurchaseWizard');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @actions
const CardCancelDeferPurchaseActions = require('actions/cardCancelDeferPurchase');

// @constants
const CLASS_NAME = 'card-cancel-defer-purchase-view';

class CardCancelDeferPurchaseView extends Component {

    constructor(props) {
        super(props);
        this.handleFinish = this.handleFinish.bind(this);
    }

    componentDidMount() {
        const { history, match: { params: { cardId, movementId } }, cancelDeferPurchaseEnabled, getCancelDeferPurchaseInfo, immCardsTransactions } = this.props;
        if (immCardsTransactions.getIn([cardId, 'byId', movementId]) && cancelDeferPurchaseEnabled) {
            getCancelDeferPurchaseInfo(cardId, movementId, immCardsTransactions);
        } else {
            history.push(`/myprofile/cards/${cardId}/movements`);
        }
    }

    componentWillUnmount() {
        const { reset } = this.props;
        reset();
    }

    buildSuccess(immCards) {
        const { immCardCancelDeferPurchase, immCardsTransactions, immAccounts, match: { params: { cardId, movementId } } } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const immMovement = immCardsTransactions.getIn([cardId, 'byId', movementId]);
        return (
            <CardCancelDeferPurchaseSuccess
                cardId={cardId}
                immAccounts={immAccounts}
                immCard={immCard}
                immCardCancelDeferPurchase={immCardCancelDeferPurchase}
                immMovement={immMovement}
            />
        );
    }

    handleFinish() {
        const { match: { params: { cardId, movementId } }, onFinish } = this.props;
        onFinish(cardId, movementId)
    }

    buildWizard() {
        const {
            getCancelDeferPurchaseInfo,
            immAccounts,
            immCardCancelDeferPurchase,
            immCardMovementInstallmentsChart,
            immCards,
            immCardsTransactions,
            onValidateStep,
            onWillCancel,
            match: { params: { cardId, movementId } },
            reset,
            setVisibleStep,
        } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        return (
            <CardCancelDeferPurchaseWizard
                cardId={cardId}
                getCancelDeferPurchaseInfo={getCancelDeferPurchaseInfo}
                immAccounts={immAccounts}
                immCard={immCard}
                immCardCancelDeferPurchase={immCardCancelDeferPurchase}
                immCardMovementInstallmentsChart={immCardMovementInstallmentsChart}
                immCardsTransactions={immCardsTransactions}
                movementId={movementId}
                onFinish={this.handleFinish}
                onValidateStep={onValidateStep}
                onWillCancel={onWillCancel}
                reset={reset}
                setVisibleStep={setVisibleStep}
            />
        );
    }

    render() {
        let content;
        const { immCards, match: { params: { cardId } }, immCardCancelDeferPurchase } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);
        const mappingBreadcrumb = [
            {
                text: formatText('breadcrumb-cards'),
                url: '/myprofile/cards'
            },
            {
                text: immCard.getIn(['alias', 'current']),
                url: `/myprofile/cards/${cardId}/movements`
            },
            {
                text: formatText('cardCancelDeferPurchase-cardCancelDeferPurchase_breadcrumbText'),
                url: ''
            }
        ];

        if (immCardCancelDeferPurchase.get('submitSuccessful')) {
            content = this.buildSuccess(immCards);
        }

        else if (immCardCancelDeferPurchase.get('fetchError') || immCardCancelDeferPurchase.get('error')) {
            content = (<CardCancelDeferPurchaseError
                cardId={cardId}
                immCard={immCard}
            >
            </CardCancelDeferPurchaseError>)
        }

        else {
            content = (
                <div className="row no-outside-gutter">
                    <div className="col-xs-12">
                        {this.buildWizard()}
                    </div>
                </div>
            );
        }
        let headerText = (<FormattedText value="cardsCancelDeferPurchase-cardsCancelDeferPurchase_headerText" />);
        return (
            <section className={CLASS_NAME}>
                <OKCover size="medium" section="cards" customClass="col-xs-12">
                    <OKHeaderSubPage
                        breadcrumbConfig={mappingBreadcrumb}
                        finalTitle={headerText}>
                        >
                    </OKHeaderSubPage>
                </OKCover>
                <section className={`${CLASS_NAME}__body`}>
                    {content}
                </section>
            </section>
        );
    }
}

CardCancelDeferPurchaseView.propTypes = {
    cancelDeferPurchaseEnabled: PropTypes.bool,
    getCancelDeferPurchaseInfo: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immCardCancelDeferPurchase: PropTypes.object.isRequired,
    immCardMovementInstallmentsChart: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardsTransactions: PropTypes.object,
    onFinish: PropTypes.func.isRequired,
    onValidateStep: PropTypes.func.isRequired,
    onWillCancel: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    reset: PropTypes.func.isRequired,
    setVisibleStep: PropTypes.func.isRequired,
};

module.exports.constructor = CardCancelDeferPurchaseView;
module.exports.CardCancelDeferPurchaseView = connect(
    (state) => ({
        cancelDeferPurchaseEnabled: state.flagBasedFeatures.get('card-cancel-deferred-purchase-enabled'),
        immAccounts: state.accounts,
        immCardCancelDeferPurchase: state.cardCancelDeferPurchase,
        immCardMovementInstallmentsChart: state.cardMovementInstallmentChart,
        immCards: state.cards,
        immCardsTransactions: state.cardsTransactions,
    }),
    {
        getCancelDeferPurchaseInfo: CardCancelDeferPurchaseActions.getCancelDeferPurchaseInfo,
        onFinish: CardCancelDeferPurchaseActions.finish,
        onValidateStep: CardCancelDeferPurchaseActions.validateStep,
        onWillCancel: CardCancelDeferPurchaseActions.setWillCancel,
        reset: CardCancelDeferPurchaseActions.reset,
        setVisibleStep: CardCancelDeferPurchaseActions.setVisibleStep

    }
)(withRouter(CardCancelDeferPurchaseView));
